import axios from "axios";
import { API, BASE_API } from "../../const";
import { normParam, serverTime } from "../../tools";
const M_API = API;

const store = {
  namespaced: true,
  state: {
    kelas: null
  },
  getters: {
    kelas(state) {
      return state.kelas;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/kelas${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getAngkatan({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/m_angkatan${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getLinkSurvei({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/tugases${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getSekolah({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/tugases${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getSpecificExt({}, params) {
      return axios
        .get(`${BASE_API}/gtk/informasi${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getLinkExt({}, { instansi_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/extapplink`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getDetailActivity({}, { params }) {
      return axios
        .get(`${BASE_API}/gtk/course-progress-detail${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getDetailPearson({}, val) {
      return axios
        .get(`${BASE_API}/gtk/pearson/detail-aktifitas/${val}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    nilaiTryout({}, params) {
      return axios
        .get(`${BASE_API}/p3k/nilai_tryout${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    statusPengimbasan({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/pengimbasan/video${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    inputVideoPengimbasan({}, { instansi_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/pengimbasan/video`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKelasDaring({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/kelas${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getJobBerkas({}, { instansi_id, kelas_id, params }) {
      return axios
        .get(`${API}/instansi/${instansi_id}/kelas/${kelas_id}/dokumen-ajukan${normParam(params)}`, {
          params: {
            progress: false
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getPeran({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/peran-kelas${normParam(params)}`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKandidat({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/user/kandidat${normParam(params)}`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detail(_, { instansi_id, diklat_id, kelas_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getJenis({}, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/jenis_kelas`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPesertaKelas({}, { instansi_id, kelas_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/user${normParam(params)}`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPengelola({}, { instansi_id, kelas_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/user${normParam(params)}`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPrasyarat({}, { instansi_id, jenis_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/jenis_kelas/${jenis_id}/prasyarat`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    missedClass({}, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/missed_class`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKelasku({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/kelasku${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getJadwal({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat_publik${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getJadwalPerJenis({}, { instansi_id, obj, jenis_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat_publik/${jenis_id}${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getBerkas(_, { instansi_id, params }) {
      return axios
        .get(`${BASE_API}/gtk/instansi/${instansi_id}/berkas_user${normParam(params)}`, {
          params: {
            progress: false
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getKuota(_, { instansi_id, obj }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/jenis_kelas/${obj.id}/kuota`, {
          params: {
            progress: false
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    unduhXLS(_, { instansi_id, kelas_id, obj }) {
      var url = `${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/unduh-data-verval`;
      window.open(url, "_blank");
    },

    // eslint-disable-next-line
    statistikVerval(_, { kelas_id }) {
      return axios
        .get(`${BASE_API}/gtk/resume_verval_pkgbi?kelas_id=${kelas_id}`, {
          params: {
            progress: false
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getLearndash(_, obj) {
      return axios
        .get(`${M_API}/diklat/${obj.diklat_id}/kelas_publik/${obj.id}/link`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    enroll({}, obj) {
      if (obj.file) {
        let formData = new FormData();
        formData.append("tugases[0][file]", obj.file);
        formData.append("tugases[0][sekolah_id]", obj.tugases[0].sekolah_id);
        formData.append("tugases[0][jenjang_id]", obj.tugases[0].jenjang_id);
        formData.append("tugases[0][is_negeri]", obj.tugases[0].is_negeri);
        formData.append("tugases[0][k_kota]", obj.tugases[0].k_kota);
        formData.append("tugases[0][nama]", obj.tugases[0].nama);
        return axios.post(`${M_API}/diklat/${obj.diklat_id}/kelas_publik/${obj.id}/selfenrol`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } else {
        return axios
          .post(`${M_API}/diklat/${obj.diklat_id}/kelas_publik/${obj.id}/selfenrol`, obj)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      }
    },
    inputNilaiXLS(_, { instansi_id, kelas_id, obj }) {
      let formData = new FormData();
      formData.append("file", obj);
      return axios.post(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/upload-nilai-kelas`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },
    // eslint-disable-next-line
    unduhVerval({}, { instansi_id, kelas_id, tipe_dokumen }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/dokumen-ajukan?tipe_dokumen=${tipe_dokumen}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    setUnduh({}, { instansi_id, kelas_id, dokumen_unduh }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/dokumen-unduh/${dokumen_unduh}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    enrollPeserta({}, { instansi_id, kelas_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/user/enrol`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    vervalPeserta({}, obj) {
      return axios
        .post(`${BASE_API}/gtk/verval_berkas`, obj, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    enrollPesertaGrup({}, obj) {
      return axios
        .post(`${BASE_API}/gtk/instansi/${obj.instansi_id}/anggota_ptk`, obj, {
          params: {
            progress: obj.is_daftar ? true : false
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    setToken({}, token) {
      return axios
        .post(`${M_API}/input_token_edp`, token)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    unenroll({}, { instansi_id, kelas_id, obj }) {
      let user_id = {
        user_id: obj[0].id
      };
      return axios
        .post(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/unenrol`, user_id)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    publish({}, obj) {
      return axios
        .post(`${M_API}/instansi/${obj.instansi_id}/kelas/${obj.id}/publish`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    nilaiPublish({}, item) {
      return axios
        .post(`${M_API}/instansi/${item.instansi_id}/kelas/${item.id}/publish-nilai?status=1`, {})
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    unpublish({}, obj) {
      return axios
        .post(`${M_API}/instansi/${obj.instansi_id}/kelas/${obj.id}/unpublish`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    pindahJadwal({}, { prevJadwal, newJadwal }) {
      return axios
        .post(`${M_API}/diklat/${prevJadwal.diklat_id}/kelas_publik/${prevJadwal.id}/pindah/${newJadwal.id}`, newJadwal)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    form(_, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/kelas/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/kelas`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    inputNilai(_, { instansi_id, kelas_id, obj }) {
      return axios
        .put(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/user`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/instansi/${item.instansi_id}/kelas/${item.id}`).then(res => {
        return res.data;
      });
    },

    // eslint-disable-next-line
    syncCourse({}, { instansi_id, kelas_id }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/sync_course`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    syncModul({}, object) {
      return axios
        .post(`${M_API}/instansi/${object.instansi_id}/diklat/${object.diklat_id}/kelas/${object.id}/syncmodul`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    unduhPeserta({}, { instansi_id, kelas_id, token }) {
      var url = `${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/unduh-anggota-kelas`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    getMapel({}, { params }) {
      return axios
        .get(`${BASE_API}/p3k/mapel${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getMapelKejuruan({}, { params }) {
      return axios
        .get(`${BASE_API}/p3k/submapel${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getJadwalTryout({}, { instansi_id, params }) {
      return axios
        .get(`${BASE_API}/p3k/kelas_modul${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKelaskuPppk({}, { params }) {
      return axios
        .get(`${BASE_API}/p3k/kelasku${normParam(params)}`, {
          params: {
            progress: false
          }
        })
        .then(res => {
          res.data.forEach(kelas => {
            kelas.server_time = serverTime(res);
          });
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    enrollPppk({}, { model, obj, params }) {
      if (model == "ubah") {
        return axios
          .put(`${BASE_API}/p3k/enroll_fasilitasi${normParam(params)}`, obj)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      } else {
        return axios
          .post(`${BASE_API}/p3k/enroll_fasilitasi${normParam(params)}`, obj)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      }
    },
    // eslint-disable-next-line
    enrollTryout({}, tahap) {
      return axios
        .post(`${BASE_API}/p3k/ajuan_tryout`, tahap)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    ketuntasanPppk({}, { instansi_id }) {
      return axios
        .get(`${BASE_API}/p3k/ketuntasan_fasilitasi`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    }
  }
};

export default store;
